import gym from '@/assets/img/users-cases/gym.webp';
import gymHow from '@/assets/img/users-cases/gym-how.webp';
import gymResult from '@/assets/img/users-cases/gym-result.webp';

export default {
  slug: 'gym-360-virtual-tour',
  order: 6,
  title: 'Gym 360 Virtual Tour',
  subtitle: '3D gym layouts with dynamic video previews',
  tags: ['gyminteriordesign', 'gymlayouts'],

  images: {
    hero: gym,
    aboutTop: gymHow,
    aboutBottom: gymResult,
  },

  howText:
    'We developed gym floor plan and layouts for gym, including 2D and 3D versions. Interior design for gym considers lighting, ventilation, and safe circulation. Zoning ensures smooth movement and ergonomic arrangement of equipment.',

  resultText:
    'Ready plans and visualizations help developers and agencies showcase gyms to clients, plan equipment, and accelerate fitness complex launch.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
